import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Image from '../../../elements/Image';
var FeatureContainer = styled.div.withConfig({
  displayName: "FeaturedArticlestyles__FeatureContainer",
  componentId: "pantheon__sc-19kfrf0-0"
})(["background-color:", ";padding:", ";margin-bottom:4rem;@media only screen and (max-width:576px){margin-bottom:2rem;}"], function (props) {
  var _props$colors;

  return ((_props$colors = props.colors) == null ? void 0 : _props$colors.featuredbg) || "transparent";
}, function (props) {
  var _props$colors2;

  return ((_props$colors2 = props.colors) == null ? void 0 : _props$colors2.featuredbg) ? "3rem 2rem" : "2rem 0rem";
});
var TileContainer = styled(Link).withConfig({
  displayName: "FeaturedArticlestyles__TileContainer",
  componentId: "pantheon__sc-19kfrf0-1"
})(["position:relative;display:flex;text-decoration:none;justify-content:center;font-family:", ";@media (max-width:992px){flex-direction:column;}"], function (props) {
  var _props$fonts;

  return ((_props$fonts = props.fonts) == null ? void 0 : _props$fonts.title) || 'Arial';
});
var CardTitle = styled.h2.withConfig({
  displayName: "FeaturedArticlestyles__CardTitle",
  componentId: "pantheon__sc-19kfrf0-2"
})(["font-size:40px;margin:0 0 0.5rem 0;line-height:1.25em;font-family:", ";color:", ";@media (min-width:992px){font-size:36px;line-height:", ";}", ";"], function (props) {
  var _props$fonts2;

  return ((_props$fonts2 = props.fonts) == null ? void 0 : _props$fonts2.title) || "Arial";
}, function (props) {
  var _props$colors3;

  return ((_props$colors3 = props.colors) == null ? void 0 : _props$colors3.title) || "black";
}, function (props) {
  return props.longtitle ? "1.08em" : "1.25em";
}, function (props) {
  var _props$theme;

  return (_props$theme = props.theme) == null ? void 0 : _props$theme.ghostTitle;
});
var ArticleImage = styled(Image).withConfig({
  displayName: "FeaturedArticlestyles__ArticleImage",
  componentId: "pantheon__sc-19kfrf0-3"
})(["height:380px;max-width:65%;object-fit:cover;background-repeat:no-repeat;background-size:cover;background-position:center center;display:block;@media (max-width:992px){max-height:350px;max-width:100%;justify-content:center;}", ";"], function (props) {
  var _props$theme2;

  return (_props$theme2 = props.theme) == null ? void 0 : _props$theme2.ghostFeaturedImage;
});
var TextContent = styled.div.withConfig({
  displayName: "FeaturedArticlestyles__TextContent",
  componentId: "pantheon__sc-19kfrf0-4"
})(["display:flex;flex-direction:column;justify-content:space-between;text-overflow:ellipsis;margin-left:3rem;@media (max-width:992px){padding-bottom:25px;margin-left:0;margin-right:15px;justify-content:center;}"]);
var ArticleContent = styled.div.withConfig({
  displayName: "FeaturedArticlestyles__ArticleContent",
  componentId: "pantheon__sc-19kfrf0-5"
})(["display:flex;flex-direction:row-reverse;width:75%;margin:0 auto;@media (max-width:992px){justify-content:center;flex-direction:column;}@media only screen and (max-width:576px){width:", ";}"], function (props) {
  var _props$colors4;

  return ((_props$colors4 = props.colors) == null ? void 0 : _props$colors4.featuredbg) ? "100%" : "90%";
});
var CardDescription = styled.div.withConfig({
  displayName: "FeaturedArticlestyles__CardDescription",
  componentId: "pantheon__sc-19kfrf0-6"
})(["margin-top:0.5rem;line-height:28px;font-family:", ";color:", ";@media (max-width:992px){display:none;}", ";"], function (props) {
  var _props$fonts3;

  return ((_props$fonts3 = props.fonts) == null ? void 0 : _props$fonts3.body) || "Arial";
}, function (props) {
  var _props$colors5;

  return ((_props$colors5 = props.colors) == null ? void 0 : _props$colors5.featuredblurb) || "black";
}, function (props) {
  var _props$theme3;

  return (_props$theme3 = props.theme) == null ? void 0 : _props$theme3.ghostFeaturedBlurb;
});
var ReadingTime = styled.div.withConfig({
  displayName: "FeaturedArticlestyles__ReadingTime",
  componentId: "pantheon__sc-19kfrf0-7"
})(["margin-top:0.5rem;color:", ";font-family:", ";", ";"], function (props) {
  var _props$colors6;

  return ((_props$colors6 = props.colors) == null ? void 0 : _props$colors6.readtime) || "black";
}, function (props) {
  var _props$fonts4;

  return ((_props$fonts4 = props.fonts) == null ? void 0 : _props$fonts4.body) || "Arial";
}, function (props) {
  var _props$theme4;

  return (_props$theme4 = props.theme) == null ? void 0 : _props$theme4.ghostReadTime;
});
export { FeatureContainer, TileContainer, CardTitle, ArticleImage, ArticleContent, CardDescription, TextContent, ReadingTime };